import Vue from "vue";
import routes from "./routes/index.js";
import storeModule from "./store-module/index.js";
import login from "./utils/login.js"

export default {
    routes: routes,
    storeModule: storeModule,
    login,
    main() {
        Vue.prototype.$showTitle = false;
        Vue.prototype.$bindInsurance = function () {
            this.$router.push("/bind-policy-for-wx-and-h5")
        }
    }
}